import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { ProfileService } from '@shared/services/profile.service';

import { environment } from '@env/environment';
import { LanguageService } from '@shared/services/language.service';
import { TokenSessionService } from '@shared/services/token.session.service';
import { UserInfo } from '@users/domain/services/user.interfaces';
import { LoginStatusUpdate, UserService } from '@users/domain/services/user.service';
import { Permission } from '@users/domain/services/user.enums';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public isLandingPage = false;
  public homeUrl = '';
  constructor(
    private languageService: LanguageService,
    public changeDetectorRef: ChangeDetectorRef
  ) {}

  public async ngOnInit(): Promise<void> {
    if (location.pathname.includes('migration') || location.pathname.includes('migration-form') || location.pathname.includes('migration-validation')) {
      this.homeUrl = location.origin.concat('/').concat(this.languageService.currentLanguage).concat('/').concat('migration');
      this.isLandingPage = true;
    }

  }
}
